module.exports = __webpack_public_path__ + "static/img/gs2.041c0e9c.jpg";